import { Component } from 'react';
import Gallery from 'react-photo-gallery';
import PhotoHomeComponent from '../components/PhotoHomeComponent';
import { Work } from '../types/WorkType';

// eslint-disable-next-line no-unused-vars
type Props = { photos: Work[]; onClick: (index: number) => void };

export default class Photos extends Component<Props> {
  getItems(photos: Work[]) {
    const worksResult: {
      id?: number;
      src: string;
      srcSet?: string | string[] | undefined;
      sizes?: string | string[] | undefined;
      width: number;
      height: number;
      alt?: string | undefined;
      key?: string | undefined;
      title?: string | undefined;
      company?: string | undefined;
      type?: number | undefined;
    }[] = [];

    for (let index = 0; index < photos.length; index++) {
      const photo = photos[index];
      worksResult[index] = {
        id: photo.id,
        src: photo.thumbnails,
        height: photo.gallery.size.height,
        width: photo.gallery.size.width,
        title: photo.title,
        company: photo.details,
        type: photo.category.id
      };
    }

    return worksResult;
  }

  getColumnsCount = (width: number): 3 | 1 => (width > 500 ? 3 : 1);

  render() {
    return this.props.photos.length ? (
      <Gallery
        key={'gallery'}
        photos={this.getItems(this.props.photos)}
        onClick={(_e, p) => this.props.onClick(p.index)}
        limitNodeSearch={3}
        margin={18}
        columns={this.getColumnsCount}
        direction={'column'}
        renderImage={PhotoHomeComponent}
      />
    ) : (
      <></>
    );
  }
}
